import React, { useState, useEffect } from "react";
import * as Url from "./urls";
import Axios from "axios";

export const createNewUserService = (
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.post(Url.createNewUserUrl, request, {
    headers: headers,
    params: params,
  });
};
export const changeUserPassword = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.changeUserPasswordUrl, request, {
    headers: headers,
    params: params,
  });
};
export const getAllUserList = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.getAllUserList, request, {
    headers: headers,
    params: params,
  });
};
export const getAllRegistrationList = (
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.post(Url.getRegistrationList, request, {
    headers: headers,
    params: params,
  });
};
export const getAllNonRegisteredUsersService = (
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.post(Url.getAllNonRegisteredUsers, request, {
    headers: headers,
    params: params,
  });
};
export const getAllFullKycList = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.getVerificationFullKycList, request, {
    headers: headers,
    params: params,
  });
};
export const getAllPartialKycList = (
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.post(Url.getVerificationPartialKycList, request, {
    headers: headers,
    params: params,
  });
};
export const getAllNoKycList = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.getVerificationNoKycList, request, {
    headers: headers,
    params: params,
  });
};
export const getAllUpdatedList = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.getUpdatedList, request, {
    headers: headers,
    params: params,
  });
};
export const getAllRejectedList = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.getRejectedList, request, {
    headers: headers,
    params: params,
  });
};
export const RegistrationDetails = (id) => {
  return Axios.get(Url.getVerificationList + id);
};

export const getUpdates = (setUpdations, setUpdatesStatus) => {
  let updates = [];

  const body = JSON.stringify({
    page: 1,
    size: 10,
  });

  fetch(Url.updates, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: body,
  }).then(function (response) {
    if (response.status == "200") {
      // flag=true;
      return response.json();
    } else {
    }
  });
};

export const getAllRejection = (
  setDataLoading,
  searchBy,
  searchByValue,
  fromDate,
  toDate,
  setRejected
) => {};
